import React from 'react'
import withStyles from 'material-ui-next/styles/withStyles'

const styles = {
  menuDivider: {
    backgroundColor: 'rgb(229, 247, 248)',
    display: 'inline-block',
    height: '24px',
    width: '1px',
    color: 'rgba(0, 0, 0, 0.4)',
    lineHeight: '10px',
  },
}

const MenuDivider = ({ classes }) => <span className={classes.menuDivider} />

export default withStyles(styles)(MenuDivider)



// WEBPACK FOOTER //
// ./src/common/TopBar/MenuDivider.js